/**
 * @file 新手指南
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

import TextCardGroup from '../../../../components/text-card/TextCardGroup';
import guidesData from './guidesData';


const Guides: React.FC = () => {
    return (
        <TextCardGroup
            className="paddle-guides"
            option={guidesData}
        />
    );
};

export default Guides;
